import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    // Statements
    OVERDUE: {
        id: 'accountTimeline.OVERDUE',
        defaultMessage: 'Overdue',
    },
    CLOSE: {
        id: 'accountTimeline.CLOSE',
        defaultMessage: 'Close',
    },
    CARD_BLOCK: {
        id: 'accountTimeline.CARD_BLOCK',
        defaultMessage: 'Card Block',
    },
    PAYMENT: {
        id: 'accountTimeline.PAYMENT',
        defaultMessage: 'Payment',
    },
    PAYMENTS: {
        id: 'accountTimeline.PAYMENTS',
        defaultMessage: 'Payments',
    },
    PARTIAL_PAYMENT: {
        id: 'accountTimeline.PARTIAL_PAYMENT',
        defaultMessage: 'Partial Payment',
    },
    // Credit
    LIMIT_NEAR: {
        id: 'accountTimeline.LIMIT_NEAR',
        defaultMessage: 'Limit Near',
    },
    LIMIT_REACHED: {
        id: 'accountTimeline.LIMIT_REACHED',
        defaultMessage: 'Limit Reached',
    },
    // Transaction
    AUTHORIZE: {
        id: 'accountTimeline.AUTHORIZE',
        defaultMessage: 'Authorized',
    },
    CANCELLATION: {
        id: 'accountTimeline.CANCELLATION',
        defaultMessage: 'Canceled',
    },
    REFUSAL: {
        id: 'accountTimeline.REFUSAL',
        defaultMessage: 'Refused',
    },
    // Card
    CREATION: {
        id: 'accountTimeline.CREATION',
        defaultMessage: 'Creation',
    },
    PRODUCTION: {
        id: 'accountTimeline.PRODUCTION',
        defaultMessage: 'Production',
    },
    DELIVERY: {
        id: 'accountTimeline.DELIVERY',
        defaultMessage: 'Delivery',
    },
    ACTIVATION: {
        id: 'accountTimeline.ACTIVATION',
        defaultMessage: 'Activation',
    },
    BLOCK: {
        id: 'accountTimeline.BLOCK',
        defaultMessage: 'Customer Blocked',
    },
    UNBLOCK: {
        id: 'accountTimeline.UNBLOCK',
        defaultMessage: 'Customer Unblocked',
    },
});

export default enumMessages;
